// latest: zhangmyh 2017-10-24 8:06 PM
import { Model } from 'common'
// 企业信息要求子表
Model.define('template.baseinfo', {
  meta: {
    id: '',
    templetId: '', // 模板审核id
    docModelId: '',
    docModelName: '',
    docModelType: '',
    docModelTypeValue: '',
    docModelProperty: '',
    docModelStrategy: '',
    docModelMatchStrategy: '',
    description: '',
    isDecision: ''
  }
})



// WEBPACK FOOTER //
// ./src/data/model/qualifyTpl/baseInfos.js